import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Dropdown from "../basic/Dropdown";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import { COLORS } from "../../constants";
import { Container, fontSize, fontWeight } from "@mui/system";

const MobileMakeModelYear = ({
                                 makeOptions,
  handleUserVehicleChange,
  loading,
  variantOptions,
  yearOptions,
  modelOptions,
  userInput,
  setUserInput,
  submit,
  showHeader = true,
}) => {
  // Handle reset by clearing userInput to default state... the placeholders
  const handleReset = () => {
    setUserInput({
      make: null,
      model: null,
      variant: null,
      year: null,
    });
  };

  return (
    <Container disableGutters sx={{ backgroundColor: COLORS.themeBlack, p: 2 }}>
      {showHeader && (
        <>
          <Typography
            sx={{
              textAlign: "center",
              color: COLORS.white,
              textTransform: "uppercase",
              fontSize: "var(--font-size-s)",
            }}
          >
            Select your vehicle
          </Typography>
          <Typography
            sx={{
              mb: 3,
              textAlign: "center",
              color: COLORS.white,
              fontWeight: 300,
              fontSize: "var(--font-size-xxs)",
            }}
          >
            We have everything your car needs
          </Typography>
        </>
      )}
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <Dropdown
            loading={loading}
            disabled={loading}
            value={userInput.make}
            onChange={handleUserVehicleChange("make")}
            options={makeOptions}
            label="Select Maker"
            darkMode={false}
            sx={{
              "& .MuiInputBase-input": {
                color: COLORS.darkText,
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            loading={loading}
            disabled={!userInput.make || loading}
            value={userInput.model}
            onChange={handleUserVehicleChange("model")}
            options={modelOptions}
            label="Select Model"
            darkMode={false}
            sx={{ "& .MuiInputBase-input": { color: COLORS.darkText } }}
          />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            loading={loading}
            disabled={(!userInput.make && !userInput.model) || loading}
            value={userInput.variant}
            onChange={handleUserVehicleChange("variant")}
            options={variantOptions}
            label="Select Variant"
            darkMode={false}
            sx={{ "& .MuiInputBase-input": { color: COLORS.darkText } }}
          />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            loading={loading}
            disabled={
              (!userInput.make &&
                !userInput.model &&
                !userInput.variant) ||
              loading
            }
            value={userInput.year}
            onChange={handleUserVehicleChange("year")}
            options={yearOptions}
            label="Select Year"
            darkMode={false}
            sx={{
              "& .MuiInputBase-input": {
                color: COLORS.darkText,
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Button
            variant="contained"
            onClick={submit}
            size="small"
            color="error"
            type="button"
            disabled={loading}
            startIcon={<SearchIcon />}
            sx={{
              backgroundColor: COLORS.themeYellow,
              color: COLORS.darkText,
              whiteSpace: "nowrap",
              padding: "0.5em",
              height: 50,
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              boxSizing: "border-box",
              borderRadius: "2px",
              fontWeight: "500",
              fontFamily: "Rubik",
              "& .MuiButton-startIcon .MuiSvgIcon-root": {
                fontSize: "1.2rem",
              },
              "&:hover": {
                backgroundColor: COLORS.themeBlack,
                color: COLORS.themeYellow,
              },
            }}
          >
            SEARCH PARTS
          </Button>
          <Button
            variant="outlined"
            onClick={handleReset}
            size="small"
            disabled={loading}
            startIcon={<RestartAltIcon />}
            sx={{
              backgroundColor: COLORS.themeYellow,
              color: COLORS.darkText,
              whiteSpace: "nowrap",
              padding: "0.5em",
              height: 50,
              flexShrink: 0,
              display: "flex",
              boxSizing: "border-box",
              borderRadius: "2px",
              "& .MuiButton-startIcon": {
                margin: 0,
                fontSize: "1.5em",
              },
            }}
          ></Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MobileMakeModelYear;
